/**
 * Estado do formulário de plano dedicado (paridade com Configurações → Planos).
 * `diskQuotaGb` é só UI; o backend recebe `diskQuota` em bytes.
 */

export const PLAN_RECURRENCE_VALUES = [
  "monthly",
  "bimonthly",
  "quarterly",
  "semester",
  "yearly"
];

export function buildPlanFormFromApi(plan) {
  if (!plan) return null;

  const diskQuotaGb = plan.diskQuota
    ? Number((plan.diskQuota / (1024 * 1024 * 1024)).toFixed(2))
    : 2;

  return {
    isPublic: plan.isPublic === true,
    trial: plan.trial === true,
    trialDays: plan.trialDays ?? 3,
    recurrence: PLAN_RECURRENCE_VALUES.includes(plan.recurrence)
      ? plan.recurrence
      : "monthly",
    users: plan.users ?? 0,
    connections: plan.connections ?? 0,
    queues: plan.queues ?? 0,
    amount:
      plan.amount != null && plan.amount !== ""
        ? String(plan.amount)
        : "0",
    useWhatsapp: plan.useWhatsapp === false ? false : true,
    useWhatsappOfficial: plan.useWhatsappOfficial === false ? false : true,
    useWhatsMeow: plan.useWhatsMeow === false ? false : true,
    useFacebook: plan.useFacebook === false ? false : true,
    useInstagram: plan.useInstagram === false ? false : true,
    useCampaigns: plan.useCampaigns === false ? false : true,
    useSchedules: plan.useSchedules === false ? false : true,
    useInternalChat: plan.useInternalChat === false ? false : true,
    useExternalApi: plan.useExternalApi === false ? false : true,
    useKanban: plan.useKanban === false ? false : true,
    useKanbanEnterprise: plan.useKanbanEnterprise === true ? true : false,
    useOpenAi: plan.useOpenAi === false ? false : true,
    useIntegrations: plan.useIntegrations === false ? false : true,
    wavoip: plan.wavoip === false ? false : true,
    useConecthub360: plan.useConecthub360 === true ? true : false,
    useTelegram: plan.useTelegram === true ? true : false,
    useGroupManagement: plan.useGroupManagement === false ? false : true,
    usePhraseListFlow: plan.usePhraseListFlow === false ? false : true,
    useConversationFlow: plan.useConversationFlow === false ? false : true,
    useFollowUp: plan.useFollowUp === false ? false : true,
    diskQuotaGb,
    checkDiskQuota: plan.checkDiskQuota === true
  };
}

export function buildDedicatedPlanSavePayload(planForm) {
  const { diskQuotaGb, ...rest } = planForm;
  const users = Number(planForm.users) || 0;
  const connections = Number(planForm.connections) || 0;
  const queues = Number(planForm.queues) || 0;
  const trialDays = Math.max(0, Number(planForm.trialDays) || 0);
  const gb = Number(diskQuotaGb);
  const diskQuota =
    Number.isFinite(gb) && gb >= 0
      ? Math.round(gb * 1024 * 1024 * 1024)
      : 2147483648;

  let amountStr = "0";
  if (planForm.amount !== undefined && planForm.amount !== null) {
    amountStr = String(planForm.amount).trim().replace(",", ".");
    if (amountStr === "") amountStr = "0";
  }

  return {
    ...rest,
    users,
    connections,
    queues,
    trialDays,
    diskQuota,
    amount: amountStr,
    isPublic: !!planForm.isPublic,
    trial: !!planForm.trial,
    checkDiskQuota: !!planForm.checkDiskQuota,
    recurrence: planForm.recurrence || "monthly"
  };
}
